<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app">
		
		<router-view></router-view>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'

export default {
	watch: {
		'$store.state.theme'(val) {
			this.toggleClassInBody(val);
		}
	},
	methods: {
		toggleClassInBody(className) {
			
			if (className == 'dark') {
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
				document.body.classList.add('theme-dark');
			} else if (className == 'semi-dark') {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
				document.body.classList.add('theme-semi-dark');
			} else {
				if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
				if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
			}
		},
		handleWindowResize(event) {
			this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
		},
	},
	created(){
		
	},
	mounted() {
		
		document.body.classList.add('contrast')
		console.log('MOUNTEDDDDDD*D*D*D*D*D*D*DD**D*D')

		this.toggleClassInBody(themeConfig.theme)
		this.$nextTick(() => {
			window.addEventListener('resize', this.handleWindowResize);
		});
		this.$store.dispatch('updateWindowWidth', window.innerWidth);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleWindowResize);
	},
}

</script>


<style lang="scss">
	#page-wrap .vs-tabs-primary button:not(:disabled):hover{
		color:white !important;
	}
	.content-tr-expand{
		background: #edf1ef;
	}
	.tooltip {
		display: block !important;
		z-index: 10000;

		.tooltip-inner {
			background: black;
			color: white;
			border-radius: 16px;
			padding: 5px 10px 4px;
		}

		.tooltip-arrow {
			width: 0;
			height: 0;
			border-style: solid;
			position: absolute;
			margin: 5px;
			border-color: black;
		}

		&[x-placement^="top"] {
			margin-bottom: 5px;

			.tooltip-arrow {
				border-width: 5px 5px 0 5px;
				border-left-color: transparent !important;
				border-right-color: transparent !important;
				border-bottom-color: transparent !important;
				bottom: -5px;
				left: calc(50% - 5px);
				margin-top: 0;
				margin-bottom: 0;
			}
		}

		&[x-placement^="bottom"] {
			margin-top: 5px;

			.tooltip-arrow {
				border-width: 0 5px 5px 5px;
				border-left-color: transparent !important;
				border-right-color: transparent !important;
				border-top-color: transparent !important;
				top: -5px;
				left: calc(50% - 5px);
				margin-top: 0;
				margin-bottom: 0;
			}
		}

		&[x-placement^="right"] {
			margin-left: 5px;

			.tooltip-arrow {
				border-width: 5px 5px 5px 0;
				border-left-color: transparent !important;
				border-top-color: transparent !important;
				border-bottom-color: transparent !important;
				left: -5px;
				top: calc(50% - 5px);
				margin-left: 0;
				margin-right: 0;
			}
		}

		&[x-placement^="left"] {
			margin-right: 5px;

			.tooltip-arrow {
				border-width: 5px 0 5px 5px;
				border-top-color: transparent !important;
				border-right-color: transparent !important;
				border-bottom-color: transparent !important;
				right: -5px;
				top: calc(50% - 5px);
				margin-left: 0;
				margin-right: 0;
			}
		}

		&[aria-hidden='true'] {
			visibility: hidden;
			opacity: 0;
			transition: opacity .15s, visibility .15s;
		}

		&[aria-hidden='false'] {
			visibility: visible;
			opacity: 1;
			transition: opacity .15s;
	}
}
.gap-1ch{
	gap:1ch;
}
</style>